const STAFF_EARLY_EDIT_STAGES = new Set(["incoming", "queue", "pending"]);
const STAFF_LATE_EDIT_STAGES = new Set(["validation", "delivery", "done"]);

export function canMutateServiceCost(role, persistedStage) {
  return role === "admin" || (role === "staff" && STAFF_EARLY_EDIT_STAGES.has(persistedStage));
}

const ADMIN_EDIT_CAPABILITIES = Object.freeze({
  canEditTicket: true,
  canUnlockAdminFields: true,
  canUnlockSharedFields: true,
  canEditGeneralFields: true,
  canEditLogisticsFields: true,
  canEditRepairAction: true,
  canEditSpareParts: true,
  canEditVoidWarranty: true,
});

const STAFF_EARLY_EDIT_CAPABILITIES = Object.freeze({
  canEditTicket: true,
  canUnlockAdminFields: false,
  canUnlockSharedFields: true,
  canEditGeneralFields: true,
  canEditLogisticsFields: true,
  canEditRepairAction: false,
  canEditSpareParts: false,
  canEditVoidWarranty: false,
});

const STAFF_LATE_EDIT_CAPABILITIES = Object.freeze({
  canEditTicket: true,
  canUnlockAdminFields: false,
  canUnlockSharedFields: false,
  canEditGeneralFields: false,
  canEditLogisticsFields: true,
  canEditRepairAction: false,
  canEditSpareParts: false,
  canEditVoidWarranty: false,
});

const NO_EDIT_CAPABILITIES = Object.freeze({
  canEditTicket: false,
  canUnlockAdminFields: false,
  canUnlockSharedFields: false,
  canEditGeneralFields: false,
  canEditLogisticsFields: false,
  canEditRepairAction: false,
  canEditSpareParts: false,
  canEditVoidWarranty: false,
});

export function getServiceEditCapabilities(role, persistedStage) {
  if (role === "admin") return ADMIN_EDIT_CAPABILITIES;
  if (role !== "staff") return NO_EDIT_CAPABILITIES;
  if (STAFF_EARLY_EDIT_STAGES.has(persistedStage)) return STAFF_EARLY_EDIT_CAPABILITIES;
  if (STAFF_LATE_EDIT_STAGES.has(persistedStage)) return STAFF_LATE_EDIT_CAPABILITIES;
  return NO_EDIT_CAPABILITIES;
}

export function canShowServiceStandardMove({ role, stage }) {
  if (role !== "admin" && role !== "staff") return false;
  if (["incoming", "queue", "pending", "delivery"].includes(stage)) return true;
  return stage === "validation" && role === "admin";
}

export function canViewDeletedServiceTickets(role) {
  return role === "admin";
}

export function canDeleteServiceTicket(role) {
  return role === "admin";
}

export function canRestoreServiceTicket(role) {
  return role === "admin";
}

export function canAccessCannibal(role) {
  return role === "admin" || role === "staff";
}

export function canMutatePreExistingRemovedParts(role) {
  return role === "admin";
}

export function canCorrectCannibalTicket(role, persistedRepairAction, nextRepairAction) {
  return ["admin", "staff"].includes(role) && nextRepairAction === "part_replace";
}
